module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-show-box"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('sl-box', {
      key: index,
      attrs: {
        "title": item.name,
        "cnt": item.number,
        "index": index
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-742e5aa0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/sl-show-box.vue
// module id = 1119
// module chunks = 1